import { useEffect } from "react";
import { Clock3, Mail, Phone, X } from "lucide-react";

type WeChatModalProps = { open: boolean; onClose: () => void };
const qrCodeUrl =
  "//cn9810.com/group1/default/20260324/13/58/6/19cca6571ebef100faaaee169f0d9063.png?name=19cca6571ebef100faaaee169f0d9063.png&download=0";

export default function WeChatModal({ open, onClose }: WeChatModalProps) {
  useEffect(() => {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    const previousPaddingRight = document.body.style.paddingRight;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto px-4 py-6">
      <button type="button" aria-label="关闭微信咨询弹窗" className="fixed inset-0 cursor-default bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative flex min-h-full items-center justify-center">
        <div className="relative w-full max-w-[340px] overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="relative bg-gradient-to-r from-[#07C160] to-[#0DAB52] px-6 py-5 text-center text-white">
          <button type="button" onClick={onClose} className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-white/20 transition-colors hover:bg-white/30" aria-label="关闭"><X size={16} strokeWidth={2.5} /></button>
          <div className="mx-auto mb-2 flex h-10 w-10 items-center justify-center text-3xl font-bold">♡</div>
          <h2 className="text-base font-semibold">微信扫码咨询</h2>
          <p className="mt-1 text-xs text-white/80">添加企业微信，获取专属顾问服务</p>
        </div>
        <div className="flex flex-col items-center px-8 py-6">
          <div className="mb-4 h-60 w-60 overflow-hidden rounded-xl border border-gray-100 shadow-sm"><img src={qrCodeUrl} alt="微信二维码" className="h-full w-full object-contain" /></div>
          <p className="mb-1 text-sm font-medium text-gray-800">扫码添加企业微信</p>
          <p className="mb-5 text-center text-xs leading-relaxed text-gray-500">专业顾问 1 对 1 解答<br />合规方案 · 价格咨询 · 技术对接</p>
          <div className="w-full space-y-2.5 border-t border-gray-100 pt-4 text-sm text-gray-600">
            <a href="mailto:ceo@g4b.cn" className="flex items-center gap-3 transition-colors hover:text-[#14B8A6]"><span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-50"><Mail size={15} className="text-gray-400" /></span>ceo@g4b.cn</a>
            <a href="tel:+8613360027991" className="flex items-center gap-3 transition-colors hover:text-[#14B8A6]"><span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-50"><Phone size={15} className="text-gray-400" /></span>13360027991</a>
            <div className="flex items-center gap-3 text-gray-400"><span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-50"><Clock3 size={15} /></span>工作日 09:00–18:00（节假日除外）</div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
